import { render, staticRenderFns } from "./blockquiz.vue?vue&type=template&id=1f04e9f6&scoped=true&"
import script from "./blockquiz.vue?vue&type=script&lang=js&"
export * from "./blockquiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04e9f6",
  null
  
)

export default component.exports